import { observer } from "mobx-react-lite";
import React, { FunctionComponent } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, FlexColumn, Text } from "designSystem/index";
import { useCustomViewDialogStore } from "../CustomViewDialogStore";
import { RuleStoreContext } from "csi/middleware/attributeRule/RuleStore";
import CustomViewFilterPane from "csi/view/customview/CustomViewFilterPane";
import { CustomViewSortingStoreContext } from "csi/view/customview/CustomViewSortingStore";
import CustomViewSortingPane from "csi/view/customview/CustomViewSortingPane";
import { CustomViewGroupingStoreContext } from "csi/view/customview/CustomViewGroupingStore";
import CustomViewGroupingPane from "csi/view/customview/CustomViewGroupingPane";
import CustomViewCalculationPane from "csi/view/customview/CustomViewReportPane";
import { CustomViewReportStoreContext } from "csi/view/customview/CustomViewReportStore";

const DataManagementTab: FunctionComponent = observer((props) => {
	const { STANDARD_PADDING, dataManagementStore } = useCustomViewDialogStore();
	const { availableRuleStores, groupingStore, reportStore, sortingStore } = dataManagementStore;

	return (
		<FlexColumn 
			data-csi-automation="DataManagementTab"
			overflow="auto"
		>
			<Box padding={STANDARD_PADDING}>
				{availableRuleStores && (
					<Accordion data-csi-automation="DataManagementFilterBy">
						<AccordionSummary>
							<Text res="CustomViewFilterPane" semiBold />
						</AccordionSummary>
						{availableRuleStores.map((store, index) => (
							<AccordionDetails key={index}>
								<RuleStoreContext.Provider value={store}>
									<CustomViewFilterPane />
								</RuleStoreContext.Provider>
							</AccordionDetails>
						))}
					</Accordion>
				)}
				{sortingStore && (
					<CustomViewSortingStoreContext.Provider value={sortingStore}>
						<CustomViewSortingPane />
					</CustomViewSortingStoreContext.Provider>
				)}
				{groupingStore && (
					<CustomViewGroupingStoreContext.Provider value={groupingStore}>
						<CustomViewGroupingPane />
					</CustomViewGroupingStoreContext.Provider>
				)}
				{reportStore && (
					<CustomViewReportStoreContext.Provider value={reportStore}>
						<CustomViewCalculationPane />
					</CustomViewReportStoreContext.Provider>
				)}
			</Box>
		</FlexColumn>
	);
});

export default DataManagementTab;